import Api from '../../common/api';

const api = Api.getApi();

export async function requestTransactionsApi({ params }) {
  const response = await api.request('get', '/orders', { params: { ...params } });
  const { data, metadata } = response;
  return { data, metadata };
}

export async function requestTransactionDetailApi({ id }) {
  const response = await api.request('get', `/orders/${id}`);
  const { data } = response;
  return data;
}

export async function requestStatusApi() {
  const response = await api.request('get', '/order_statuses', {});
  const { data, metadata } = response;
  return { data, metadata };
}
